import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';
import { useLocationStore } from '@/stores/useLocationStore';

export interface FilterOption {
    id: string;
    label: string;
    count: number;
}

export interface CatalogFiltersResponse {
    brands: FilterOption[];
    ageRanges: FilterOption[];
    categories: FilterOption[];
}

export interface CatalogFilterParams {
    locationId?: string;
}

/**
 * Fetches dynamic catalog filters (brands, age ranges) from the API.
 * Filters are based on actual inventory data.
 */
export const getCatalogFilters = async (params: CatalogFilterParams): Promise<CatalogFiltersResponse> => {
    const response = await api.get<CatalogFiltersResponse>('/customer/equipment-types/filters', {
        params,
    });
    return response.data;
};

/**
 * Hook to fetch dynamic catalog filters.
 * Automatically uses the selected location from the store.
 */
export const useCatalogFilters = () => {
    const { location } = useLocationStore();

    return useQuery({
        queryKey: ['catalogFilters', location?.id],
        queryFn: () => getCatalogFilters({ locationId: location?.id }),
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });
};
